import React, { Component } from 'react';
import {Field, reduxForm} from "redux-form";
import {connect} from "react-redux";
import {updateGame} from "../../actions/index";
import {TREASURE_DESCRIPTION, TREASURE_TYPE, WIN_CODE} from "../../constants/Game";
import {minLength2, required} from "../../constants/ValidationRules";
import {renderArea} from "../common_page_elements";
import {TreasureTypeChoice} from "./TreasureTypeChoice";

/**
 * Goes inside a modal to update just the location name/description.
 */
class HuntEnding extends Component {
    constructor(props) {
        super(props);

        const treasureType = props.game ? props.game[TREASURE_TYPE] : null;

        this.state = {
            treasureType,
            isFetching: false
        };

        this.onTreasureTypeChange = this.onTreasureTypeChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    static renderField(reduxField) {
        const { input, name, label, placeholder, type, isRow, meta: { touched, error, warning } } = reduxField;
        const className = `form-group ${touched && error ? 'has-danger ' : ''}${isRow ? 'row' : ''}`;
        const labelClass = `${isRow ? 'col-sm-2 col-form-label' : ''}`;
        const innerDivClass = `${isRow ? 'col-sm-10' : ''}`;
        const errorClass = `text-danger ${isRow ? 'push-right-one-sixth' : ''}`;

        return (
            <div className={className}>
                <label htmlFor={name} className={labelClass}>{label}</label>
                <div className={innerDivClass}>
                    <input
                        className="form-control"
                        type={type}
                        placeholder={placeholder}
                        {...input}
                    />
                </div>
                {touched &&
                ((error && <span className={errorClass}>{error}</span>) ||
                    (warning && <span className={errorClass}>{warning}</span>))}
            </div>
        );
    }

    onSubmit(values) {
        const { game, afterDoneCallback } = this.props;

        if (!this.state.treasureType) {
            alert("Treasure type is required");
            return;
        }

        this.setState( { isFetching: true });

        // If there is no win code, we must explicitly omit it since our initial values caused it to be present (even as undefined.)
        if (values[WIN_CODE] == null) {
            delete values[WIN_CODE]
        }

        this.props.updateGame(game.id, game.isPublic, values, () => {
            afterDoneCallback();
        });
    }

    onTreasureTypeChange(event, newValue) {

        this.setState( { treasureType: newValue });
    }

    render() {
        const { handleSubmit, isWizard, isModal, afterDoneCallback, onCancelCallback } = this.props;

        const noTopPadding = {
            paddingTop: '0px'
        };

        return (
            <div>
                {isModal &&
                    <button
                        style={noTopPadding}
                        className="btn btn-link pull-right"
                        onClick={afterDoneCallback}>

                        X
                    </button>
                }
                {isModal &&
                    < h4 > Hunt Ending </h4>
                }

                <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>

                <TreasureTypeChoice
                    useShort={isModal}
                    treasureType={this.state.treasureType}
                    onChange={this.onTreasureTypeChange}
                />

                <Field
                    name={TREASURE_DESCRIPTION}
                    type="textarea"
                    component={renderArea}
                    rows={3}
                    label="Message"
                    placeholder="Short message to the user after game is over.  Might contain description of treasure, congratulatory message, call to action, or anything."
                    validate={[required, minLength2]}
                />
                   <p className="bottom-margin secondary-text">Note you can come back and change almost all of these fields later.</p>

                    {isModal &&
                    <button type="submit">
                        Save
                    </button>
                    }
                    {isWizard &&
                        <div>
                            <button type="button" onClick={onCancelCallback}
                                    className="btn btn-danger right-margin">Cancel
                            </button>

                            <button type="submit" className="btn btn-primary left-margin">Next</button>
                        </div>
                    }
                </form>
                {this.state.isFetching && <div className="loader"/>}
            </div>
        )
    }
}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
HuntEnding = reduxForm({
    form: 'UpdateHuntEndingForm' // a unique identifier for this form
})(
    connect(null, { updateGame }
    )(HuntEnding));

// You have to connect() to any reducers that you wish to connect to yourself

HuntEnding = connect(
    state => {
        const { games, selectedGameId } = state;
        const selectedGame = (games && selectedGameId) ? games[state.selectedGameId] : null;

        const initialValues = selectedGame
            ?  {
                [TREASURE_DESCRIPTION]: state.games[state.selectedGameId][TREASURE_DESCRIPTION],
                [WIN_CODE]: state.games[state.selectedGameId][WIN_CODE]
            }
            : { };

        return {
            initialValues,
        }
    }
)(HuntEnding);

export default HuntEnding;



// WEBPACK FOOTER //
// ./src/components/huntcomponents/HuntEnding.js